export default "20260612.1 \r\n"